/**
 * UI locale from API language (`__APP_DATA__.lang`, GET /languages, Vuex `lang`).
 * Prefer explicit API fields; otherwise normalize `code` (BCP 47). No hardcoded alias tables.
 */

function normalizeLocaleTag(raw) {
    const s = String(raw ?? '').toLowerCase().trim().replace(/_/g, '-');
    if (!s) return '';
    return s;
}

export function resolveUiLocale(langOrCode) {
    if (langOrCode == null || langOrCode === '') return 'en';

    if (typeof langOrCode === 'string' || typeof langOrCode === 'number') {
        const tag = normalizeLocaleTag(langOrCode);
        if (!tag) return 'en';
        return tag;
    }

    if (typeof langOrCode === 'object') {
        const explicit =
            langOrCode.locale
            ?? langOrCode.vuetify_locale
            ?? langOrCode.help_center_locale
            ?? langOrCode.zendesk_locale
            ?? langOrCode.iso_code;
        const fromExplicit = normalizeLocaleTag(explicit);
        if (fromExplicit) return fromExplicit;

        const fromCode = normalizeLocaleTag(langOrCode.code);
        if (fromCode) return fromCode;
    }

    return 'en';
}

/** Best locale for VDatePicker / Intl — first tag the browser supports. */
export function resolveCalendarLocale(langOrCode) {
    const normalized = resolveUiLocale(langOrCode);
    if (!normalized) return 'en';

    const parts = normalized.split('-');
    const base = parts[0] || 'en';
    const candidates = parts.length > 1
        ? [normalized, base]
        : [normalized, `${base}-${base.toUpperCase()}`, base];

    try {
        const supported = Intl.DateTimeFormat.supportedLocalesOf(candidates);
        if (supported.length) return supported[0];
    } catch (_) {}

    return base || 'en';
}
